module.exports = __webpack_public_path__ + "img/DSC_2661-xs.061ac52e.png";